import axios from 'axios';
const { functions } = require('../config/fbConfig.js');
const { fbConfig, functionsKeys, TSEnvironment } = require('../config/keys.js');

const IMPORT_PYNS_BY_PLACE_SEARCH_ID_CALL = 'pyns-loadPlacesByRequestCall';
const CONVERT_PYNS_IMPORTED_TO_PINS_BY_PLACE_SEARCH_ID_CALL = 'pyns-convertPynsImportedToPynsRequestCall';
const CREATE_DATABASE_CALL = 'sqlite-generateSQLiteDatabaseCall';
const READJUST_LEVELS = 'levels-readjustLevelsForAllUsers';
const SEND_DAILY_NOTIFICATIONS = 'notifications-sendDailyNotifications';
const MANUAL_UPDATE_RANKING = 'manualUpdateRanking';
const MANUAL_SCORES_CALCULATION = 'manualScoresCalculation';
const IMPORT_PYNS_PEACE_HILL = 'pyns-importPynsByPeaceHill';
const GET_POSTAL_CODES = 'pyns-getPostalCodes';
const INVITE_CODE_EXISTS = 'inviteCodes-inviteCodeExists';
const SEND_INVITE_CODE_TO_USER = 'inviteCodes-sendInviteCodeToUser';
const CREATE_TEST_DATA_CONTEST = 'contests-createTestDataForContest';
const MANUAL_GET_WINNER_CONTEST = 'contestEntries-manualGetWinnerOfContestsFinished';
const DELETE_CONTEST_ENTRIES_BY_CONTEST = 'contestEntries-deleteContestEntriesByContest';
const UPDATE_TIMEZONES = 'timezones-updateTimezones';
const SEARCH_PLACES_PEACE_HILL = 'place-searchPlaces';
const ASSIGN_WEEKLY_MISSIONS_TO_USER_IDS = 'weeklyMission-assignWeeklyMissionToUserIds';
const MANUAL_AUTOMATIC_ASSIGNMENT_WEEKLY_MISSIONS = 'weeklyMission-manualAutomaticAssignment';
const RUN_CONTEST_BY_ID = 'contests-runContestById';
const SEND_NOTIFICATION_TO_WINNERS = 'contests-sendNotificationToWinners';
const FINISH_CONTEST = 'contests-finishContest';
const GET_USER_TRIVIA_RESULT_BY_DAY = 'userTriviaResults-getUserTriviaResultByDay';
const VERIFY_USER_MISSION_DATA = 'userMissions-verifyUserMissionData';
const TRIVIA_RESET_QUESTIONS = 'trivia-resetQuestions';
const UPLOAD_QUESTIONS = 'triviaQuestions-createQuestions';
const ASSIGN_QUESTIONS = 'triviaQuestions-assignQuestions';
const ADD_DAY_FIELD_TO_QUESTIONS = 'triviaQuestions-addDayToQuestions';
const IMPORT_TRYP_STOPS = 'pyns-importTrypStops';
const MIGRATE_NOTIFICATIONS_TO_ACTIVITIES = 'activities-migrateNotificationsToActivities';
const IMPORT_PYNS_FROM_FILE = 'pyns-importPyns';
const UPDATE_PYNS_FROM_FILE = 'pyns-updatePyns';
const ADD_DISPLAY_TO_PYNS = 'pyns-addDisplayFieldToPynsByCompany';
const IMPORT_PRIZES = 'prizes-importPrizes';
const CREATE_PYNS_DB_BATCHES = 'sqlite-generatePynsDatabaseInBatches';
const MIGRATION_COMPANIES96 = 'companies-migrationOfCompaniesV96';
const MIGRATION_PYNS96 = 'pyns-migrationOfPynsV96';
const DELETE_TRIVIA_QUESTION = 'triviaQuestions-deleteQuestion';
const CREATE_MESSAGE_TEMPLATES = 'messageTemplates-createMessageTemplate';
const MIGRATE_NOTIFICATIONS_TO_USER_INBOX = 'userInboxMessages-migrateNotifications';
const SEND_CUSTOM_MESSAGE = 'userInboxMessages-sendCustomMessage';
const CALCULATE_COUNTERS_OF_MESSAGE_TEMPLATES = 'messageTemplates-calculateCounters';
const ADD_ID_TO_CONTEST_COUNTERS = 'userContestCounters-addIdToUserContestCounters';
const ADD_NAME_TO_CONTEST_COUNTERS = 'contests-addNameFieldToContests';

const RETRY_TO_FINISH_SIGN_UP = 'user-retryToFinishSignUp';
const UPDATE_MAX_USERS = 'waitListConfig-updateMaxUsers';
const SCHEDULE_NEW_MESSAGE = 'scheduleMessages-scheduleNewMessage';
const MANUAL_SEND_SCHEDULE_MESSAGE = 'scheduleMessages-manualSendScheduleMessages';

const GET_DRIVING_SAFE_SINCE = 'profiles-getDrivingSafeSinceBy';
const CALCULATE_CURRENT_USERS = 'profiles-calculateCurrentUsers';
const GET_INCOMPLETE_PROFILES = 'profiles-getIncompleteProfiles';
const UPDATE_GENDER_FIELD = 'profiles-updateGenderField';
const UPDATE_LICENSE_TYPE_FIELD = 'profiles-updateLicenseTypeField';
const DELETE_FULL_PROFILE = 'profiles-deleteFullProfile';
const ASSIGN_CONTACT_LIST_TO_ALL_PROFILES = 'profiles-assignContactListToAllProfiles';
const ADD_PROFILE_CREATION_DATES = 'profiles-addCreationDateToAllProfiles';

const MANUAL_CREATE_TRIVIA_ENTRIES = 'contestEntries-manualCreateTriviaEntries';
const MANUAL_CREATE_MISSION_ENTRIES = 'contestEntries-manualCreateWeeklyMissionEntries';
const MANUAL_CREATE_PYN_COLLECTOR_ENTRIES = 'contestEntries-manualCreatePynCollectorEntries';
const MANUAL_CREATE_PYN_COLLECTOR_FILTERED_ENTRIES = 'contestEntries-manualCreatePynCollectorFilteredEntries';
const PEACE_HILL_CONTEST_NOTIFICATION_MIGRATION = 'messageTemplates-peaceHillContestNotificationMigration';
const MOVE_ENTRIES_BATCH_TO_HISTORY = 'contestEntries-moveEntriesBatchToHistory';

if (TSEnvironment.ENABLE_FUNCTIONS) {
  functions.useFunctionsEmulator("http://localhost:5000");
}

class Functions {
  copyLastNotificationsToActivities = () => {
    const functionMigrate = functions.httpsCallable(MIGRATE_NOTIFICATIONS_TO_ACTIVITIES);
    return functionMigrate();
  };

  importPynsByPlaceSearchIdCall = (placeSearchId) => {
    const importPynsByPlaceSearchIdFunction = functions.httpsCallable(IMPORT_PYNS_BY_PLACE_SEARCH_ID_CALL);
    return importPynsByPlaceSearchIdFunction({
      placeSearchId,
    });
  };

  convertPynsImportedToPynsByPlaceSearchIdCall = (placeSearchId) => {
    const convertPynFunction = functions.httpsCallable(CONVERT_PYNS_IMPORTED_TO_PINS_BY_PLACE_SEARCH_ID_CALL);
    return convertPynFunction({
      placeSearchId,
    });
  };

  createDatabaseCall = (schema) => {
    const createDatabaseFunction = functions.httpsCallable(CREATE_DATABASE_CALL);
    return createDatabaseFunction({
      body: schema,
    });
  };

  readjustLevels = (levels) => {
    const readjustLevelsFunction = functions.httpsCallable(READJUST_LEVELS);
    return readjustLevelsFunction({
      levels: levels,
    });
  };

  sendDailyNotification = (userId) => {
    const sendDailyNotification = functions.httpsCallable(SEND_DAILY_NOTIFICATIONS);
    return sendDailyNotification({
      userId: userId,
      now: true
    });
  };

  manualUpdateRanking = () => {
    const manualRankingCalculation = functions.httpsCallable(MANUAL_UPDATE_RANKING);
    return manualRankingCalculation();
  };

  updateTimezones = () => {
    const functionUpdateTimezones = functions.httpsCallable(UPDATE_TIMEZONES);
    return functionUpdateTimezones();
  };

  manualScoresCalculation = () => {
    const manualUpdateScores = functions.httpsCallable(MANUAL_SCORES_CALCULATION);
    return manualUpdateScores();
  };

  importPynsPeaceHill = (lat, lng, radius, idCompany, countryCode) => {
    const importPynsPeaceHill = functions.httpsCallable(IMPORT_PYNS_PEACE_HILL);
    return importPynsPeaceHill({
      lat: lat,
      lng: lng,
      radius: radius,
      idCompany: idCompany,
      countryCode: countryCode,
    });
  };

  getPostalCodes = (url) => {
    const getPostalCodes = functions.httpsCallable(GET_POSTAL_CODES);
    return getPostalCodes({
      url,
    });
  };

  getDrivingSafeSince = (userId) => {
    const getDrivingSafeSince = functions.httpsCallable(GET_DRIVING_SAFE_SINCE);
    return getDrivingSafeSince({ userId });
  };

  inviteCodeExists = (inviteCode) => {
    const getInviteCodeExists = functions.httpsCallable(INVITE_CODE_EXISTS);
    return getInviteCodeExists({ inviteCode });
  };

  sendInviteCodeToUser = (userId, email, inviteCode) => {
    return functions.httpsCallable(SEND_INVITE_CODE_TO_USER)({ userId, email, inviteCode });
  };

  addCreationDateToAllProfiles = () => {
    const addCreationDate = functions.httpsCallable(ADD_PROFILE_CREATION_DATES);
    return addCreationDate();
  };

  updateGenderField = () => {
    const updateGenderField = functions.httpsCallable(UPDATE_GENDER_FIELD);
    return updateGenderField();
  };

  updateLicenseTypeField = () => {
    const updateLicenseTypeField = functions.httpsCallable(UPDATE_LICENSE_TYPE_FIELD);
    return updateLicenseTypeField();
  };

  createTestDataContest = (userIds) => {
    const functionCreateTestDataContest = functions.httpsCallable(CREATE_TEST_DATA_CONTEST);
    return functionCreateTestDataContest({ userIds });
  };

  manualCreateTriviaEntries = (day) => {
    return functions.httpsCallable(MANUAL_CREATE_TRIVIA_ENTRIES)({ day });
  };

  manualCreateMissionEntries = () => {
    return functions.httpsCallable(MANUAL_CREATE_MISSION_ENTRIES)();
  };

  manualCreatePynCollectorEntries = () => {
    return functions.httpsCallable(MANUAL_CREATE_PYN_COLLECTOR_ENTRIES)();
  };

  manualCreatePynCollectorFilteredEntries = () => {
    return functions.httpsCallable(MANUAL_CREATE_PYN_COLLECTOR_FILTERED_ENTRIES)();
  };

  manualGetWinnerContest = () => {
    const functionManualGetWinnerContest = functions.httpsCallable(MANUAL_GET_WINNER_CONTEST);
    return functionManualGetWinnerContest();
  };

  searchPlaces = (places) => {
    const functionSearchPlaces = functions.httpsCallable(SEARCH_PLACES_PEACE_HILL);
    return functionSearchPlaces({ places });
  };

  assignWeeklyMissionToUserIds = (missionId, userIds) => {
    const functionAssign = functions.httpsCallable(ASSIGN_WEEKLY_MISSIONS_TO_USER_IDS);
    return functionAssign({ missionId, userIds });
  };

  manuallyDoAutomaticWeeklyMissionAssignment = (missionId, userIds) => {
    const functionAutomaticAssign = functions.httpsCallable(MANUAL_AUTOMATIC_ASSIGNMENT_WEEKLY_MISSIONS);
    return functionAutomaticAssign();
  };

  runContestById = (contestId) => {
    const runContestById = functions.httpsCallable(RUN_CONTEST_BY_ID);
    return runContestById({ contestId });
  };

  sendNotificationToWinners = (contestId) => {
    const sendNotification = functions.httpsCallable(SEND_NOTIFICATION_TO_WINNERS);
    return sendNotification({ contestId });
  };

  finishContest = (contestId) => {
    const finishContestCall = functions.httpsCallable(FINISH_CONTEST);
    return finishContestCall({ contestId });
  };

  sendCustomNotification = (profileIds, notification, pushNotification, image) => {
    const functionSendCustomNotification = functions.httpsCallable(SEND_CUSTOM_MESSAGE);
    return functionSendCustomNotification({
      profileIds,
      notification,
      pushNotification,
      image,
    });
  };

  verifyUserMissionData = (userMissionId) => {
    const verifyUserMission = functions.httpsCallable(VERIFY_USER_MISSION_DATA);
    return verifyUserMission({ userMissionId });
  };

  getUserTriviaResultByDay = (day) => {
    const functionGetUserTriviaResult = functions.httpsCallable(GET_USER_TRIVIA_RESULT_BY_DAY);
    return functionGetUserTriviaResult({ day });
  };

  deleteFullProfile = (userId) => {
    const functionDeleteFullProfile = functions.httpsCallable(DELETE_FULL_PROFILE);
    return functionDeleteFullProfile({ userId });
  };

  assignContactListToAllProfiles = () => {
    const functionAssignContactListToAllProfiles = functions.httpsCallable(ASSIGN_CONTACT_LIST_TO_ALL_PROFILES);
    console.log(functionAssignContactListToAllProfiles);
    return functionAssignContactListToAllProfiles();
  }


  resetQuestions = (userIds) => {
    const functionResetQuestions = functions.httpsCallable(TRIVIA_RESET_QUESTIONS);
    return functionResetQuestions({ userIds });
  };

  uploadQuestions = (questions) => {
    const functionUploadQuestions = functions.httpsCallable(UPLOAD_QUESTIONS);
    return functionUploadQuestions({ questions });
  };

  assignQuestions = (profiles, selectQuestions, replaceQuestion) => {
    const functionAssignQuestions = functions.httpsCallable(ASSIGN_QUESTIONS);
    return functionAssignQuestions({ profiles, selectQuestions, replaceQuestion });
  };

  addDayFieldToQuestions = (day) => {
    const functionAddDayField = functions.httpsCallable(ADD_DAY_FIELD_TO_QUESTIONS);
    return functionAddDayField({ day });
  };

  importTrypStops = (trypStops) => {
    const functionImportTrypStops = functions.httpsCallable(IMPORT_TRYP_STOPS);
    return functionImportTrypStops({ trypStops });
  };

  deleteContestEntriesByContest = (contestId) => {
    const deleteContestEntriesByContestCall = functions.httpsCallable(DELETE_CONTEST_ENTRIES_BY_CONTEST);
    return deleteContestEntriesByContestCall({ contestId });
  }

  importPynsFromFile = (pyns) => {
    const functionImportPyns = functions.httpsCallable(IMPORT_PYNS_FROM_FILE);
    return functionImportPyns({ pyns });
  };

  updatePynsFromFile = (pyns) => {
    const functionUpdatePyns = functions.httpsCallable(UPDATE_PYNS_FROM_FILE);
    return functionUpdatePyns({ pyns });
  };

  addDisplayFieldToPyns = (companyId, trypStopCompanyId) => {
    const functionAddDisplayToPyns = functions.httpsCallable(ADD_DISPLAY_TO_PYNS);
    return functionAddDisplayToPyns({ companyId, trypStopCompanyId });
  };

  importPrizes = (prizes) => {
    const functionImportPrizes = functions.httpsCallable(IMPORT_PRIZES);
    return functionImportPrizes({ prizes });
  };

  createPynsDBInBatches = (schema, dbName, lastDoc) => {
    const createDatabaseFunction = functions.httpsCallable(CREATE_PYNS_DB_BATCHES);
    return createDatabaseFunction({ body: schema, dbName, lastDoc });
  };

  migrationCompanies96 = () => {
    const addFieldsToCompany = functions.httpsCallable(MIGRATION_COMPANIES96);
    return addFieldsToCompany();
  };

  migrationPyns96 = () => {
    const addFieldsToCompany = functions.httpsCallable(MIGRATION_PYNS96);
    return addFieldsToCompany();
  };

  deleteTriviaQuestion = (question) => {
    const functionDeleteTriviaQuestion = functions.httpsCallable(DELETE_TRIVIA_QUESTION);
    return functionDeleteTriviaQuestion({ question });
  };

  createMessageTemplate = (messageTemplate) => {
    const functionCreateMessageTemplates = functions.httpsCallable(CREATE_MESSAGE_TEMPLATES);
    return functionCreateMessageTemplates({ messageTemplate });
  };

  migrateNotifications = () => {
    const functionMigrateNotifications = functions.httpsCallable(MIGRATE_NOTIFICATIONS_TO_USER_INBOX);
    return functionMigrateNotifications();
  };

  calculateCountersOfMessageTemplates = (templateId) => {
    const functionCalculateCounters = functions.httpsCallable(CALCULATE_COUNTERS_OF_MESSAGE_TEMPLATES);
    return functionCalculateCounters({ templateId });
  };

  calculateCurrentUsers = () => {
    const functionCalculateCurrentUsers = functions.httpsCallable(CALCULATE_CURRENT_USERS);
    return functionCalculateCurrentUsers();
  };

  getIncompleteProfiles = () => {
    const functionGetIncompleteProfiles = functions.httpsCallable(GET_INCOMPLETE_PROFILES);
    return functionGetIncompleteProfiles();
  };

  retryToFinishSignUp = (userId) => {
    const functionRetryToFinishSignUp = functions.httpsCallable(RETRY_TO_FINISH_SIGN_UP);
    return functionRetryToFinishSignUp({ userId });
  };

  updateMaxUsers = (maxUsers) => {
    const functionUpdateMaxUsers = functions.httpsCallable(UPDATE_MAX_USERS);
    return functionUpdateMaxUsers({ maxUsers });
  };

  scheduleNewMessage = (scheduleMessage) => {
    const functionScheduleNewMessage = functions.httpsCallable(SCHEDULE_NEW_MESSAGE);
    return functionScheduleNewMessage({ scheduleMessage });
  };

  manualSendScheduleMessage = () => {
    const functionSendScheduleMessage = functions.httpsCallable(MANUAL_SEND_SCHEDULE_MESSAGE);
    return functionSendScheduleMessage();
  };

  addIdToUserContestCounters = () => {
    return functions.httpsCallable(ADD_ID_TO_CONTEST_COUNTERS)();
  };

  peaceHillContestNotificationMigration = () => {
    return functions.httpsCallable(PEACE_HILL_CONTEST_NOTIFICATION_MIGRATION)();
  };

  moveEntriesBatchToHistory = ({ entries }) => {
    return functions.httpsCallable(MOVE_ENTRIES_BATCH_TO_HISTORY)({ entries });
  };
  
  addNameToUserContestCounters = () => {
    return functions.httpsCallable(ADD_NAME_TO_CONTEST_COUNTERS)();
  };
}
export default new Functions();
